import React from "react";
import URI from "urijs";
import { ChevronUnactive } from "@speedoc/design-assets/build/icons/index";
import { GlobalStore } from "../../stores/global";
const flagUri = new URI("//public.speedoc.com/design/images/speedoc.com/flags/");

const getCountryLink = countryCode =>
  countryCode.toString().toLowerCase() === "sg" ? "https://sg.speedoc.com/en" : "https://my.speedoc.com/en";

const CountrySelector = ({ countryCode, countryName }) => {
  const countries = GlobalStore.useState(c => c.countries);

  return (
    <div className="countries">
      <div className="selectedCountry">
        <img
          className="flag"
          src={flagUri
            .segment(-1, countryCode === "MY" ? "my" : "sg")
            .suffix("svg")
            .toString()}
          alt={`country flag for ${countryName}`}
        />
        <span>{countryName}</span>
        <ChevronUnactive className="chevron" />
      </div>

      <ul className="dropdownCountries">
        {countries.map(({ twoLetterCode, name }) => (
          <li key={`country-${twoLetterCode}`}>
            <a href={getCountryLink(twoLetterCode)} type="button" className="country">
              <img
                src={flagUri
                  .segment(-1, twoLetterCode === "MY" ? "my" : "sg")
                  .suffix("svg")
                  .toString()}
                alt={`country flag for ${name}`}
              />
              <span>{name}</span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CountrySelector;
